import { KoncentroBaseModel } from './koncentro-base.model';

export class BackofficeSystem extends KoncentroBaseModel {
  public dto = 'BackofficeSystemDto';

  public id?: number;
  public code: string;
  public name: string;
  public description: string;
  public img_b64: string;
  public img_url: string;
  public flg_state: number;
}



// WEBPACK FOOTER //
// ./src/app/models/backoffice-system.model.ts